"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var Icon = function Icon(_ref) {
  var element = _ref.element,
      link = _ref.link,
      className = _ref.className,
      children = _ref.children,
      size = _ref.size,
      other = _objectWithoutProperties(_ref, ["element", "link", "className", "children", "size"]);

  var T = link ? "a" : element;
  return _react2.default.createElement(T, _extends({
    className: (0, _classnames3.default)("cdkicon-" + children, _defineProperty({
      "cdk-icon--link": link
    }, "cdk-icons md-" + size, size !== 24), className)
  }, other));
};

Icon.propTypes = {
  /** The HTML element to render */
  element: _propTypes.string,

  /** The name of the icon to render */
  children: _propTypes.string,

  /** Render the icon as an <a> */
  link: _propTypes.bool,

  /** Set the icon size **/
  size: (0, _propTypes.oneOf)([18, 24, 36, 48])
};
Icon.defaultProps = {
  element: "i",
  size: 24
};
exports.default = Icon;